import { observable, action } from 'mobx'

export interface CommonIntl {
  lang: string
  browserLanguage: string
}

class IntlCommon {
  // public LanguageArr = ['en', 'zh', 'ko', 'ja', 'tw', 'ms', 'th']
  public LanguageArr = ['en', 'zh']
  public MomentMes = {
    en: 'en-ca',
    zh: 'zh-cn',
    tw: 'zh-tw',
    ko: 'ko',
    ja: 'ja',
    ms: 'ms',
    th: 'th',
  }

  public hasLang = this.LanguageArr.some(
    (item: any) => navigator.language.split('-')[0] === item
  )
  // 判断是简体还是繁体
  // @observable public lang: string = this.hasLang
  //   ? navigator.language.split('-')[0] === 'zh' &&
  //     navigator.language.split('-')[1] !== 'CN'
  //     ? 'tw'
  //     : navigator.language.split('-')[0]
  //   : 'zh'

  @observable public lang: string = this.hasLang ? navigator.language.split('-')[0] : 'zh'

  // 获取语言
  @observable public browserLanguage: string =
    localStorage.getItem('browserLanguage') || this.lang

  @observable public intlFun = {}

  @action public setBrowserLanguage = (language: string) => {
    this.browserLanguage = language
  }

  @action public setIntlFun = (val: any) => {
    this.intlFun = val
  }
}

export default new IntlCommon()
